import loadable from "@loadable/component";
import { isLeft } from "fp-ts/lib/Either";
import { inject } from "mobx-react";

import { Remote } from "../components/remote/Remote.component";
import * as Webapi from "@ihr-radioedit/inferno-webapi";
import { getContest, ContestEmbedResolver, ContestEmbedLegacyLoaderProps } from "@ihr-radioedit/inferno-core";

const ContestEmbedLegacy = loadable(() => import("./ContestEmbedLegacy.component"));

export const ContestEmbedLegacyLoader = inject("store")(({ store, ...block }: ContestEmbedLegacyLoaderProps) => {
  const blockValue = ContestEmbedResolver.decode(block);
  if (!store || isLeft(blockValue)) {
    return null;
  }

  const { call_letters, contest_id, url } = blockValue.right;
  const cacheKey = `contestembedlegacyloader-${call_letters}-${contest_id}`;

  return (
    <Remote<Webapi.AptivadaAppFragment | null | undefined>
      cacheKey={cacheKey}
      loader={() =>
        getContest({ accountId: call_letters, appId: `${contest_id}` }, store.tags.surrogateKeys, store.getSdkOpts())
      }
      showLoading={false}
    >
      {({ data }) => (data ? <ContestEmbedLegacy {...data} url={url} /> : null)}
    </Remote>
  );
});

export default ContestEmbedLegacyLoader;
